import { render, staticRenderFns } from "./VidyardVideoModal.vue?vue&type=template&id=3323249c&"
import script from "./VidyardVideoModal.vue?vue&type=script&lang=ts&"
export * from "./VidyardVideoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports